export default "__VITE_ASSET__CaJfGeui__"